import api from './api';
import { 
  Battery, 
  BatteryFilters, 
  BatteryListResponse 
} from '../types/api';

/**
 * Serviço de Baterias/Produtos
 */
const batteryService = {
  /**
   * Lista baterias com filtros e paginação
   */
  async list(filters?: BatteryFilters): Promise<BatteryListResponse> {
    // Remover parâmetros vazios ou undefined para evitar erro de validação
    const cleanFilters = filters ? Object.fromEntries(
      Object.entries(filters).filter(([, value]) => {
        if (value === undefined || value === null) return false;
        if (typeof value === 'string' && value.trim() === '') return false;
        if (Array.isArray(value) && value.length === 0) return false;
        return true;
      })
    ) : {};

    type RawBatteryListResponse = BatteryListResponse & {
      products?: Battery[];
    };

    const response = await api.post<{ success: boolean; data: RawBatteryListResponse }>('/products', cleanFilters);
    const data = response.data.data;

    return {
      ...data,
      batteries: data.batteries ?? data.products ?? []
    };
  },

  /**
   * Retorna detalhes de uma bateria por ID
   */
  async getById(id: string): Promise<{ battery: Battery }> {
    const response = await api.get<{ success: boolean; data: { battery: Battery } }>(`/batteries/${id}`);
    return response.data.data;
  },

  /**
   * Retorna bateria pelo slug
   */
  async getBySlug(slug: string): Promise<{ battery: Battery }> {
    const response = await api.get<{ success: boolean; data: { battery: Battery } }>(`/batteries/slug/${slug}`);
    return response.data.data;
  },

  /**
   * Retorna baterias em destaque
   */
  async getFeatured(): Promise<{ batteries: Battery[] }> {
    const response = await api.get<{ success: boolean; data: { batteries: Battery[] } }>('/batteries/featured');
    return response.data.data;
  },

  /**
   * Busca avançada de baterias
   */
  async search(params: {
    q?: string;
    vehicle?: string;
    brand?: string;
    model?: string;
    year?: number;
  }): Promise<{ batteries: Battery[]; suggestions: string[] }> {
    const response = await api.get<{ success: boolean; data: { batteries: Battery[]; suggestions: string[] } }>(
      '/batteries/search',
      { params }
    );
    return response.data.data;
  },

  /**
   * Retorna baterias compatíveis com um veículo
   */
  async getCompatibleBatteries(params: {
    brand: string;
    model: string;
    year: string;
  }): Promise<{ batteries: Battery[] }> {
    const response = await api.get<{ success: boolean; data: { batteries: Battery[] } }>(
      '/vehicles/compatible-batteries',
      { params }
    );
    return response.data.data;
  },
};

export default batteryService;

